import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { PauseCircleFilled, PlayCircleFilledWhite } from "@mui/icons-material";
import * as React from "react";
import { CSSProperties } from "react";

interface IPlayerProps {
    //   parameters: any;
    play: () => void;
    pause: () => void;
    color: "default" | "inherit" | "primary" | "secondary";

    status: PlayStatus;
    hoverMessage?: HoverMessages;
    style?: CSSProperties;
}

class HoverMessages {
    playMessage: string = "Play";
    pauseMessage: string = "Pause";
}

export enum PlayStatus {
    Play,
    Paused,
    Stopped,
}

const PlayControl = ({
    play,
    pause,
    status,
    color,
    hoverMessage,
    style,
}: IPlayerProps) => {
    const theme = useTheme();
    if (hoverMessage === undefined) {
        hoverMessage = new HoverMessages();
    }
    const iconSize = useMediaQuery(theme.breakpoints.down("lg"))
        ? "small"
        : "large";
    switch (status) {
        case PlayStatus.Play:
            return (
                <Tooltip title={hoverMessage.pauseMessage}>
                    <IconButton
                        onClick={pause}
                        color={color}
                        sx={{ padding: 1 }}
                        size="large"
                    >
                        <PauseCircleFilled style={style} fontSize={iconSize} />
                    </IconButton>
                </Tooltip>
            );
        default:
            return (
                <Tooltip title={hoverMessage.playMessage}>
                    <IconButton
                        onClick={play}
                        color={color}
                        sx={{ padding: 1 }}
                        size="large"
                    >
                        <PlayCircleFilledWhite
                            style={style}
                            fontSize={iconSize}
                        />
                    </IconButton>
                </Tooltip>
            );
    }
};

export default PlayControl;
